import { NodeIndexOutlined } from "@ant-design/icons"
import "./TemplatesMenu.scss"

export default function SolutionsMenu() {
  return (
    <div className={"templates-menu solutions-menu"}>
      <ul>
        <li>
          <a href="/feature/digital-menu-board-solution.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/DSABlack.svg" alt="digial signage"/>
            <span>Digital Signage</span>
          </a>
        </li>
        <li>
          <a href="/feature/easy-menu-design-for-restaurants.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="menu designer"/>
            <span>Menu Designer</span>
          </a>
        </li>
        <li>
          <a href="/feature/menu-services.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="menu services"/>
            <span>Menu Services</span>
          </a>
        </li>
        <li>
          <a href="/feature/Print-Services.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Printer.svg" alt="print services"/>
            <span>Print Services</span>
          </a>
        </li>
        <li>
          <a href="/feature/restaurant-menu-management.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/MenuManagement.svg" alt="menu management"/>
            <span>Menu Management Software</span>
          </a>
        </li>
        <li>
          <a href="/feature/online-menu.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/OnlineMenus.svg" alt="online menus"/>
            <span>Online Menus</span>
          </a>
        </li>
        <li>
          <a href="/feature/menu-qr-code.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="qr menus"/>
            <span>QR Menus</span>
          </a>
        </li>
        <li>
          <a href="/feature/restaurant-landing-pages.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/MegaphoneFilled.svg" alt="link pages"/>
            <span>Link Pages</span>
          </a>
        </li>
        <li>
          <a href="/content/toast-partner-connect">
            <NodeIndexOutlined/>
            <span>POS Integration</span>
          </a>
        </li>
        <li>
          <a href="/feature/senior-living-menu-design.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/drd-greyscale.svg" alt="drd menus"/>
            <span>DiningRD Integration</span>
          </a>
        </li>
      </ul>
    </div>
  );
}
